/*eslint-disable */
import {
  mapGetters
} from 'vuex';
import adapter from 'webrtc-adapter';
const $ = window.jQuery = require('jquery');
import chatbot from '../../components/user-chatbot/index.vue';
import DashSidebar from '../../components/dashboard-sidebar/index.vue';
import videoSocketRef from "../../videoNotificationSocket";
import videoCallNotification from '../../components/video-call-notification-popup/index.vue';
import audioPlay from '../../assets/audio/caller_ringtone.mp3';
import acknowledgementPopup from '../../components/user-acknowledgement-popup/index.vue';
var audioPlayer;
import {
  bus
} from '../../main';
export default {
  name: 'dashboard',
  components: {
    'user-chatbot' : chatbot,
    'dash-sidebar' : DashSidebar,
    'video-call' : videoCallNotification,
    'acknowledgement-popup':acknowledgementPopup
  },
  props: [],
  data () {
    return {
      userDetails:{},
      soketForUserId:'',
      incomingCallNotification:false,
      callerName:'',
      hasWebrtcSupport: true,
      isClosed: true,
      currentUserId: null,
      userAcknowledgement:false,
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
  },
  setIntialStates(){
    if(this.userDetails != undefined){
      this.soketForUserId = this.userDetails.id
      // if(!this.userDetails.acknowledgement){
      //   $('body').addClass('acknowledgement_popup_show')
      //   this.userAcknowledgement = true
      // }
    }
    return
  }
  },
  mounted () {
    this.currentUserId = localStorage.getItem('LoginedUserID');
    if(localStorage.getItem('LoginedUserID'))
    if(sessionStorage.getItem('isClosed')) {
      this.isClosed = sessionStorage.getItem("isClosed");
    } else {
      this.isClosed = false;
    }
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    }
    this.$store.dispatch('getAuthHeader');
    this.getUserDetailsAgainFun
    this.setIntialStates
    bus.$emit('showHeaderbtn', true);
    $(".preloader").delay(200).fadeOut("slow");
    console.log(this.$route.name)
    setTimeout(() => {
    if(localStorage.getItem('token') && this.$route.name != 'videoChat'  && this.$route.name != 'videoChatOneToOnePeer'){
      this.videoNotficationAlertPopupForSocket()
    }
    }, 800);
    bus.$on('callerNotifiactionBus', (data) => {
      this.incomingCallNotification = data;
    });
    if(this.hasUserMedia() && this.hasRTCPeerConnection()) {
      let safariVersion = 0;
      if(adapter.browserDetails.browser === 'safari') {
        safariVersion = this.getBrowserVersion()
      }
      console.log(`Browser ${adapter.browserDetails.browser} - version ${adapter.browserDetails.version}`);
      if((adapter.browserDetails.browser == "chrome" && adapter.browserDetails.version > 50) || (adapter.browserDetails.browser == "firefox" && adapter.browserDetails.version > 45) || (adapter.browserDetails.browser == "safari" && safariVersion > 11) ) {
        this.hasWebrtcSupport = true;
       } else {
        this.hasWebrtcSupport = false;
      }
    } else {
      this.hasWebrtcSupport = false;
    }

    bus.$on('sendRequestMessage', (data) => {
      const payload = {
        message: "Friend Request",
        type: "friendRequest",
        userID: data.to_user,
        fromUserID: data.from_user
      };
      videoSocketRef.emit(payload);
    });
    bus.$on('newChatMessage', (data) => {
      const payload = {
        type: "newChatMessage",
        message: "New Chat Message",
        fromUserID: data.fromUserID,
        toUserID: data.toUserID,
        chatRoomId: data.chatRoomId
      };
      videoSocketRef.emit(payload);
    });
    // bus.$on('userAcknowledgementEmitter', (data) => {
    //   this.userAcknowledgement = data
    // })
  },
  methods: {
    getBrowserVersion() {
        var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M[1];
    },
    closeModal() {
      sessionStorage.setItem("isClosed", true);
      this.isClosed = true;
    },
    /*
    * this will check if user has getUserMedia
    */
    hasUserMedia() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      return !!navigator.getUserMedia;
    },
    /*
    * this will check that user browser supports webrtc or not
    */
    hasRTCPeerConnection() {
      window.RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
      window.RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window.mozRTCIceCandidate;
      return !!window.RTCPeerConnection;
    },
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    videoNotficationAlertPopupForSocket(){
        let callerID = '3548d149becb44e9';
        videoSocketRef.connect(callerID);
        videoSocketRef.$on('connection', response => {
          const payload = {
            type: "userLogin",
            userID: this.currentUserId,
            message: "User Login"
          };
          videoSocketRef.emit(payload);
        });
        videoSocketRef.$on('userLogin', this.handleUserLogin);
        videoSocketRef.$on('userLogout', this.handleUserLogout);
        videoSocketRef.$on('videoCallingNotification', this.getVideoNotificationMsg);
        videoSocketRef.$on('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs);
        videoSocketRef.$on('friendRequest', this.handleFriendRequest);
        videoSocketRef.$on('newMessageNotification', this.handleNewMessageNotification);
    },
    handleNewMessageNotification(response) {
      const toUserID = response.toUserID;
      const fromUserID = response.fromUserID;

      if(fromUserID == this.currentUserId || toUserID != this.currentUserId) return;

      try {
        const payload = {
          toUserID: response.toUserID,
          fromUserID: response.fromUserID,
          unreadCount: response.unreadCount,
          totalUnreadCount: response.totalUnreadCount
        };
        bus.$emit('updateMessageNotification', payload);
        bus.$emit('updateMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }

    },
    getVideoNotificationMsg(getData){
      if(this.soketForUserId == getData.targetId){
        $('body').addClass('videoNotificationPopup')
        this.callerName = getData.displayName
        this.incomingCallNotification = true
        this.playSound(audioPlay)
      }
    },
    callerPopupClosedInOtherTabs(closeOtherTabData){
      if(closeOtherTabData.type == 'videoAlertPopupClose'){
        // clearInterval(audioPlayer)
        $('body').removeClass('videoNotificationPopup')
        this.callerName = ''
        this.incomingCallNotification = false
      }
    },
    closeSocket() {
      if(videoSocketRef.isOpen()) {
        videoSocketRef.close();
      }
    },
    handleFriendRequest(response) {
      const userID = response.userID;
      const fromUserID = response.fromUserID;

      if(fromUserID == this.currentUserId || userID != this.currentUserId) return;

      try {
        const payload = {
          userID
        };
        bus.$emit('userFriendRequest', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogout(response) {
      const userID = response.userID;

      if(userID == this.currentUserId) return;

      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogin(response) {
      const userID = response.userID;

      if(userID == this.currentUserId) return;

      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    }
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    setIntialStates(){
      if(this.userDetails != undefined){
        this.soketForUserId = this.userDetails.id
        // if(!this.userDetails.acknowledgement){
        //   $('body').addClass('acknowledgement_popup_show')
        //   this.userAcknowledgement = true
        // }
      }
      return
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.closeSocket)
  },

  beforeDestroy() {
    if(videoSocketRef.isOpen()) {
      videoSocketRef.close();
    }
    window.removeEventListener("beforeunload", this.closeSocket);
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
    $('body').removeClass('videoNotificationPopup')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    $('body').removeClass('videoNotificationPopup')
    next();
  },
}
